import routes from '@/modules/guide/guide-routes';
import store from '@/modules/guide/guide-store';

export default {
  routes,
  store,
};
